import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let debug = process.env.NODE_ENV !== 'production'
const routes = [
    {
        path: '/',
        name: 'index',
        component: () => import('@views/Home')
    },
    {
        path: '/index',
        name: 'index',
        component: () => import('@views/Home')
    },
    {
        path: '/404',
        component: () => import('@views/ErrorPage/404'),
        hidden: true
    },
    {
        path: '/500',
        component: () => import('@views/ErrorPage/500'),
        hidden: true
    },
    {
        path: '/policy/list',
        name: 'PolicyList',
        component: () => import('@views/PolicyRegulation/PolicyList'),
    },
    {
        path: '/policy/detail',
        name: 'PolicyDetail',
        component: () => import('@views/PolicyRegulation/PolicyDetail'),
    },
    {
        path: '/credit-publicity/list',
        name: 'CreditPublicityList',
        component: () => import('@views/CreditPublicity/List'),
    },
    {
        path: '/credit-publicity/detail',
        name: 'CreditPublicityDetail',
        component: () => import('@views/CreditPublicity/Detail'),
    },
    {
        path: '/institutional-publicity',
        name: 'InstitutionalPublicity',
        component: () => import('@views/InstitutionalPublicity'),
    },
    {
        path: '/complaints-report',
        name: 'ComplaintsReport',
        component: () => import('@views/ComplaintsReport/ComplaintsList'),
    },
    {
        path: '/data-hall',
        name: 'DataHall',
        component: () => import('@views/DataHall/DataList'),
    },
    {
        path: '/handling-guide',
        name: 'HandlingGuide',
        component: () => import('@views/HandlingGuide/HandlingList'),
    },
    {
        path: '/guarantee-check-true/search',
        name: 'GuaranteeCheckTrueSearch',
        component: () => import('@views/GuaranteeCheckTrue/Search'),
    },
    {
        path: '/guarantee-check-true/result',
        name: 'GuaranteeCheckTrueResult',
        component: () => import('@views/GuaranteeCheckTrue/Result'),
    }

]
export default new Router({
    linkActiveClass:'router-link-active',
    routes: routes,
    strict: debug,
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    base: process.env.VUE_APP_ROUTER_BASE || '/',
    mode: process.env.VUE_APP_ROUTER_MODE || 'hash'
})


